import Axios from "axios";
import config from "../app.config";

export var broadcastService;
export default broadcastService = {
    getListBroadcast: getListBroadcast,
    getListMailSendByBroadcastId: getListMailSendByBroadcastId,
    exportMailSend: exportMailSend,
}

async function getListBroadcast() {
    return await Axios.get(`${config.LOCAL_API_URL}/getListBroadcast`)
        .then(response => {
            if(response.data) {
                return Promise.resolve(response.data);
            } else {
                return Promise.reject(response);
            }
        }).catch(error =>{
            return Promise.reject(error);
        })
}
async function getListMailSendByBroadcastId(payload) {
    return await Axios.get(`${config.LOCAL_API_URL}/getListMailSendByBroadcastId`,{ params: payload })
        .then(response => {
            if(response.data) {
                return Promise.resolve(response.data);
            } else {
                return Promise.reject(response);
            }
        }).catch(error =>{
            return Promise.reject(error);
        })
}
async function exportMailSend(payload) {
    return await Axios.get(`${config.LOCAL_API_URL}/exportMailSend`,{ params: payload })
        .then(response => {
            if(response.data) {
                return Promise.resolve(response.data);
            } else {
                return Promise.reject(response);
            }
        }).catch(error =>{
            return Promise.reject(error);
        })
}
